import { useMemo } from "react";

import { UnitSelectDropdown } from "@/domain/unit/components/unit-select-dropdown";
import { useGetUnitList } from "@/domain/unit/hooks/api/use-get-unit-list";

import { SelectTriggerButton } from "./select-trigger-button";

interface UnitSelectFieldProps {
  workspaceId: string;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

export function UnitSelectField({ workspaceId, value, onChange, disabled }: UnitSelectFieldProps) {
  const { unitList } = useGetUnitList({ workspaceId });

  const displayName = useMemo(() => {
    const unit = unitList.find((u) => u.id === value);
    if (!unit) return "";
    return unit.symbol ? `${unit.title} (${unit.symbol})` : unit.title;
  }, [unitList, value]);

  return (
    <UnitSelectDropdown
      workspaceId={workspaceId}
      defaultValue={value || undefined}
      onSelect={(unitId) => onChange(unitId ?? "")}
      asChild
      modal
    >
      <SelectTriggerButton value={displayName} disabled={disabled} />
    </UnitSelectDropdown>
  );
}
